import { HandleVibrate } from "./HandleApiData";

export default function ActionButton({ icon, onClick, className, disabled, hidden }) {
    const onMouseUp = (e) => {
        HandleVibrate();
    }
    return (
        <div
            className={`btn ${className ? className : ''} ${disabled ? 'disabled' : ''} ${hidden ? 'hidden' : ''}`}
            onClick={onClick}
            onMouseUp={onMouseUp}
        >
            {icon}
        </div>
    );
}